export default theme => ({
  customMultiplier: {
    '& [class*="Section"]': {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridColumnGap: 16,
      paddingBottom: 8,
      paddingTop: 8,
      '& > [class*="isFullWidth"]': {
        gridColumn: '1 / span 2'
      },
      '& [class*="InputWrapper"]': {
        width: '100%'
      }
    },
    '& [class*="removeIcon"]': {
      marginTop: '52px !important'
    },
    '& [class*="separator"]': {
      borderBottomColor: theme.colors.grey[100]
    }
  },
  overlayLabel: {
    position: 'absolute',
    minWidth: 15,
    top: 0,
    marginLeft: -8,
    textAlign: 'center',
    color: theme.colors.utility.textSecondary,
    fontSize: 12,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: theme.typography.letterSpacing
  }
});